<template>
  <div class="logo-section">
    <router-link to="/" class="home-link">
      <div class="d-flex">
        <img src="/s-images/logo-white2.svg" class="drawer_header" alt="logo" />
        <sub v-if="isDev">dev</sub>
      </div>
    </router-link>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AsideLogo',

    computed: {
      ...mapGetters({
        isDev: 'app/appIsDev',
      }),
    },
  }
</script>

<style lang="less" scoped>

.logo-section {
  padding: 20px 23px 0 23px;
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;

  img {
    width: 214px;
    max-width: 100%;
  }

  .home-link {
    text-decoration: none;
    @media (min-width: @md) {
      display: block;
      width: 100%;

      .drawer_header {
        width: 100%;
      }
    }
  }

  sub {
    font-size: 8px;
    color: white;
    text-decoration: none !important;
    text-transform: uppercase;
  }

  // Свёрнутый сайдбар компактного десктопа: логотипа нет - высота полоски
  // отдана пунктам меню, они должны помещаться без прокрутки
  .navigation-drawer-component--collapsed & {
    display: none;
  }

  // Развёрнутый поверх страницы: место под кнопку сворачивания справа
  .navigation-drawer-component--over & {
    padding-right: 70px;
  }
}

/*.logo-section {
  padding-left: 18px;
  padding-top: 18px;
  margin-bottom: 25px;

}*/

</style>
